import Swiper from "swiper/bundle";
import { setupAddToCartListeners, showSizesVariants } from "./collections";
import { initMobileCategoryCarousel } from "./components/mobile-category-carousel";
import { initSideCartQuickPay } from "./components/sidecart-quick-pay";
import { tabsCollections } from "./components/tabs-collections";
import productCarouselHomepage from "./components/product-carousel-banner-home";
import { initNavigationMobile } from "./components/navigation-mobile";
import { initReviewsCarousel } from "./components/reviews-carousel";

initSideCartQuickPay();

const tabsCollectionsHome = document.querySelectorAll('.tabs-collections__collection');

if (tabsCollectionsHome.length) {
  tabsCollectionsHome.forEach(tab => {
    const swiperContainer = tab.querySelector('.tabs-collections_slider');
    const swiper = new Swiper(swiperContainer, {
      slidesPerView: 6,
      spaceBetween: 25,
      loop: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        320: {
          slidesPerView: "auto",
          spaceBetween: 10,
          mousewheel: {
            forceToAxis: true,
            invert: true,
          }

        },
        768: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 25,
        },
        1200: {
          slidesPerView: 6,
        },
      },
    });
  });
}

// document.addEventListener('resize', () => {
//   setupAddToCartListeners();
//   showSizesVariants();
// });

document.addEventListener("DOMContentLoaded", () => {
  initMobileCategoryCarousel();
  setupAddToCartListeners();
  showSizesVariants();
  tabsCollections();
  initNavigationMobile();
  initReviewsCarousel();
  productCarouselHomepage();
});

document.addEventListener('DOMContentLoaded', function () {
  const carouselAthle = document.querySelectorAll('.swiper-container-lp');
  const carouselAthleDawn = document.querySelectorAll('.lp-athletes-items.swiper-container');
  carouselAthleDawn.forEach(container => {
    new Swiper(container, {
      loop: true,
      slidesPerView: 4,
      spaceBetween: 40,
      navigation: {
        nextEl: '.next',
        prevEl: '.prev',
      },
      /* autoplay: {
        delay: 2000, 
        disableOnInteraction: false, 
      }, */
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        425: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: 3,
        },
        1280: {
          slidesPerView: 4,
        }
      }
    });
  });
  carouselAthle.forEach(container => {
    const products = container.querySelectorAll('.swiper-slide').length;
    console.log("Los Productos son "+products)
    if (products > 3) {
      // Inicializar Swiper normalmente si hay más de 3 productos
      new Swiper(container, {
        spaceBetween: 30,
        loop: true,
        navigation: {
          nextEl: '.nextt',
          prevEl: '.prevv',
        },
        breakpoints: {
          767: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
          },
          768: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            spaceBetween: 30,
          },
        },
      });
    } else {
      container.classList.add('limited-items');
      console.log(window.matchMedia('(max-width: 767px)').matches)
      if (window.matchMedia('(max-width: 767px)').matches) {
        new Swiper(container, {
          spaceBetween: 30,
          loop: true,
          navigation: {
            nextEl: '.nextt',
            prevEl: '.prevv',
          },
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
        });
      }
    }
  });
});
